export default __webpack_public_path__ + "static/media/statusDone.75a96f39.png";